import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    startDate: null,
    endDate: null,
  },
  rows: [],
  fetched: false,
};

const leadReportSlice = createSlice({
  name: "leadReport",
  initialState,

  reducers: {
    saveLeadReport(state, action) {
      state.filter = action.payload.filter;
      state.rows = action.payload.rows;
      state.fetched = action.payload.fetched;
    },

    clearLeadReport(state) {
      state.filter = initialState.filter;
      state.rows = [];
      state.fetched = false;
    },
  },
});

export const { saveLeadReport, clearLeadReport } = leadReportSlice.actions;

export default leadReportSlice.reducer;
